import React from 'react';
import Enquiry from '../features/enquiry';

const EnquiryPage = () => {
  return <Enquiry />;
};

export default EnquiryPage;
